export const LogEventCategory = {
  AUTH: 'auth',
  NAVIGATION: 'navigation',
  ACCESS: 'access',
  SESSION: 'session',
  ERROR: 'error',
  USER_ROLE: 'user-role',
  INTEGRATION_AUTH: 'integration-auth',
  INTEGRATION_API: 'integration-api',
  FILES: 'files',
  INSTRUMENTATION: 'instrumentation',
  DATABASE_ERROR: 'database_error',
  DATABASE_OPERATION: 'database_operation',
} as const;

export const LogEvent = {
  UNAUTHORIZED_ACCESS: 'unauthorized_access',
  LOGIN_SUCCESS: 'login_success',
  SESSION_EXPIRED: 'session_expired',
  INVITE_ACCEPTED: 'invite_acceptance',
  MODULE_LOOKUP_FAILED: 'module_lookup',
  FALLBACK_HOMEPAGE: 'fallback_homepage',
  MISSING_SUB: 'missing_sub',
  ACCOUNT_DETAILS: 'account_details',
  USER_DETAILS: 'user_details',
  EXISTING_USER: 'existing_user',
  LINKING_EXISTING_USER: 'linking_existing_user',
  NO_ACCOUNT_FOUND: 'no_account_found',
  FAILED_LOGIN: 'failed_login',
  INSTRUMENTATION_INFO: 'instrumentation_info',
} as const;

export type LogEventCategoryType =
  (typeof LogEventCategory)[keyof typeof LogEventCategory];

export type LogEventType = (typeof LogEvent)[keyof typeof LogEvent];
